import axios from 'axios'

import { receiveSuccessAlert } from '../../actions/alerts'
import { handleRequestError } from '../../actions/request'
import config from '../../config'
import { ERROR_MESSAGE_SAVING } from '../../constants'
import { profileSelector } from '../../selectors'
import { PROFILE } from '../action-types'
import { invalidateProfile } from './api'

const ACCESS_STRIPE_CUSTOMER_PORTAL = 'ACCESS_STRIPE_CUSTOMER_PORTAL'

export const requestProfile =
    ({ shouldInvalidateProfile } = { shouldInvalidateProfile: true }) =>
    (dispatch, getState) => {
        if (shouldInvalidateProfile) dispatch(invalidateProfile())
        const { profile } = getState()

        const { id } = profile

        dispatch({ type: PROFILE.REQUEST_PROFILE, data: { id } })

        return axios
            .get(`/users/${id}`)
            .then((response) => {
                const data = response?.data || {}
                dispatch(receiveProfile({ ...data, fetchSuccessful: true }))
                return data
            })
            .catch((error) => {
                dispatch(handleRequestError(error))
            })
    }

export const receiveProfile = (data) => ({ type: PROFILE.RECEIVE_PROFILE, data })

export const updateAndSaveProfile = (data, options) => (dispatch) => {
    dispatch({ type: PROFILE.UPDATE_AND_SAVE_PROFILE, data })

    dispatch(receiveProfile(data))
    return dispatch(saveProfile(data, options))
}

export const saveProfile =
    (data, { hideAlert } = {}) =>
    (dispatch, getState) => {
        dispatch(invalidateProfile())
        dispatch({ type: PROFILE.SAVE_PROFILE, data })

        const { profile } = getState()
        const { id: userId } = profile

        return axios
            .put(`/users/${userId}`, {
                ...profile,
                ...data,
            })
            .then((response) => {
                const updatedProfile = response?.data

                dispatch(receiveProfile(updatedProfile))

                if (!hideAlert) {
                    dispatch(receiveSuccessAlert('Perfil actualizado'))
                }

                return updatedProfile
            })
            .catch((error) => {
                dispatch(handleRequestError(error, { customMessage: ERROR_MESSAGE_SAVING }))
                return Promise.reject(error)
            })
    }

export const saveIsSelfEmployed =
    ({ isSelfEmployed, ...data }, options) =>
    (dispatch, getState) => {
        dispatch({ type: PROFILE.SAVE_IS_SELF_EMPLOYED })

        const state = getState()
        const profile = profileSelector(state)
        const { hasActiveSubscription, isSelfEmployed: currentIsSelfEmployed } = profile

        if (isSelfEmployed === currentIsSelfEmployed) return Promise.resolve()

        dispatch(invalidateProfile())

        return dispatch(
            saveProfile(
                {
                    isSelfEmployed: !!hasActiveSubscription || isSelfEmployed,
                    ...data,
                },
                { ...options, hideAlert: true }
            )
        )
    }

export const saveIsNewSelfEmployed =
    ({ isNewSelfEmployed, ...data }, options) =>
    (dispatch, getState) => {
        dispatch({ type: PROFILE.SAVE_IS_SELF_EMPLOYED })

        const state = getState()
        const profile = profileSelector(state)
        const { isTaxRegistrationStarted, isNewSelfEmployed: currentIsNewSelfEmployed } = profile

        if (isNewSelfEmployed === currentIsNewSelfEmployed) return Promise.resolve()

        dispatch(invalidateProfile())

        return dispatch(
            saveProfile(
                {
                    isNewSelfEmployed: isTaxRegistrationStarted || isNewSelfEmployed,
                    ...data,
                },
                { ...options, hideAlert: true }
            )
        )
    }

export const assignAccountant = (productType) => (dispatch, getState) => {
    dispatch(invalidateProfile())
    dispatch({ type: PROFILE.ASSIGN_ACCOUNTANT, productType })

    const { id: userId } = getState().profile

    return axios
        .put(`/users/${userId}/accountant`, productType, { headers: { 'Content-Type': 'application/json' } })
        .then((response) => {
            const data = response?.data || {}
            dispatch(receiveProfile({ ...data, fetchSuccessful: true }))

            const { accountantId } = data
            return accountantId
        })
        .catch((error) => {
            if (error?.status === 404) {
                dispatch(receiveProfile({ fetchSuccessful: true }))
                return
            }

            dispatch(receiveProfile({ fetchSuccessful: false }))

            dispatch(handleRequestError(error))
        })
}

export const accessStripeCustomerPortal = () => (dispatch, getState) => {
    dispatch({ type: ACCESS_STRIPE_CUSTOMER_PORTAL })

    const { id: userId } = getState().profile

    return axios
        .post(`/users/${userId}/stripeCustomerPortalSession?returnUrl=${config.stripeCallbackUri}profile/subscriptions`)
        .then(({ data: stripeCustomerPortalUrl }) => {
            dispatch(receiveProfile({ ...stripeCustomerPortalUrl, fetchSuccessful: true }))
            return stripeCustomerPortalUrl
        })
        .catch((error) => {
            if (error?.status === 404) {
                return
            }

            dispatch(handleRequestError(error))
        })
}

export const syncProfile = (data) => (dispatch) => {
    dispatch(invalidateProfile())
    dispatch({ type: PROFILE.SYNC_PROFILE, data })
}
